export default {
    maptiler: {
        url:
            "https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=KBuB0XnGfjq4JZRCB04b",
        attribution:
            '&copy; <a href="https://www.maptiler.com/">MapTiler</a> &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    },
};